import React, { Component } from "react";
import { connect } from "react-redux";

import { setModal } from "./store/actions";

import "./Modal.scss";

import { Modal as ModalWrapper } from "@learningblocks/shared-components/lib/Modal";
import style from "./style.module.scss";

const DynamicModalComponent = ({ modalKey, modals }) => {
  const SpecificComponent = modals[modalKey];

  if (!SpecificComponent) {
    console.log("Modal not found", modalKey);
    return null;
  }

  // Render the specific component
  return <SpecificComponent />;
};

class ModalHandler extends Component {
  close = () => {
    this.props.setModal({
      display: false,
    });
  };

  render() {
    return (
      <ModalWrapper
        className={style.protocol_modal}
        closeButton={this.props.type !== "LEVEL_CHOICE" ? true : false}
        close={this.close}
        isOpen={this.props.display}
        notebookExpanded={
          this.props.type !== "LEVEL_CHOICE"
            ? this.props.notebookExpanded
            : false
        }
        fullScreen={
          this.props.type === "LEVEL_CHOICE" ||
          this.props.type === "END_SIMULATION"
        }
        lang={"en"} // TODO: Fix this
      >
        <div className={"Modal " + this.props.size}>
          <div style={{ height: "100%" }}>
            <div className="wrapper">
              <DynamicModalComponent
                modalKey={this.props.type}
                modals={this.props.modals}
              />
            </div>
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    display: state.modal.display,
    type: state.modal.type,
    size: state.modal.size,
    connect: state.modal.connect,
  };
};

export default connect(mapStateToProps, {
  setModal,
})(ModalHandler);
